import styled from '@emotion/styled';
import React from 'react';
import { RouteComponentProps } from 'react-router-dom';

import { BrandWrapper } from 'src/modules/onboarding/components/BrandWrapper';
import { Button } from 'src/shared/components/Button';
import { color, font } from 'src/shared/styles/variables';

import { useTranslation } from 'react-i18next';
import image from 'src/public/img/marginalia-done.svg';

const Wrapper = styled.div({
    maxWidth: 492,
    width: '100%',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    flex: 1,
    paddingBottom: 100,
});

const Image = styled.img({
    width: 200,
    alignSelf: 'center',
});

const HeaderText = styled.h3({
    color: color.pickledBluewood,
    marginBottom: 25,
    textAlign: 'center',
    ...font.black(font.size.extraLarge),
});

const DescriptionText = styled.p({
    color: color.blueBayoux,
    marginBottom: 50,
    lineHeight: '24px',
    textAlign: 'center',
    ...font.book(font.size.medium),
});

export const PreSessionAssessmentsScorePage: React.FC<RouteComponentProps> = ({ history }) => {
    const { t } = useTranslation();

    return (
        <BrandWrapper>
            <Wrapper>
                <Image src={image} />
                <HeaderText>{t('assessments:pre_session_assessment_score.title')}</HeaderText>
                <DescriptionText>
                    {t('assessments:pre_session_assessment_score.description')}
                </DescriptionText>

                <Button onClick={() => history.push('/')} widthPercentage={100} noHorizontalPadding>
                    {t('common.continue')}
                </Button>
            </Wrapper>
        </BrandWrapper>
    );
};
